import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/crews/alerts";
import qs from "qs";

/**
 * 船員アラート一覧取得
 * 
 * @param {Object} params - 以下の条件で絞り込みが可能です。
 * details:
 *   - CREW_AVAILABLE_ROLE
 *   - CREW_LICENSE
 *   - CREW_RESPONSIBILITY
 * kinds:
 *   - CREW_COMPATIBILITY
 *   - CREW_UNREGISTERED
 *   - DAY_OFF_REQUEST_DUPLICATED
 *   - DISEMBARKATION_STANDBY
 *   - EMBARKATION_STANDBY
 *   - LICENSE_EXPIRED
 */
export default {
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },  
};
